import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AddEventForm = () => {
  const navigate = useNavigate();
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [formData, setFormData] = useState({
    officialNameId: '',
    startDate: '',
    startTime: '',
    endDate: '',
    endTime: '',
    clientPhone: '',
    eventTitle: '',
    eventDescription: '',
    meetLink: '',
    documents: null,
    clientId: ''
  });

  // Fetch clients when component mounts
  useEffect(() => {
    const fetchClients = async () => {
      try {
        const response = await fetch('https://admindashboard.clns.in/api/dashboard/client_list/');
        
        if (response.ok) {
          const result = await response.json();
          setClients(result.data);
        } else {
          console.error('Failed to fetch clients');
        }
      } catch (error) {
        console.error('Error fetching clients:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchClients();
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleClientSelect = (e) => {
    const selectedClientId = e.target.value;
    const selectedClient = clients.find(client => client.id.toString() === selectedClientId);
    
    setFormData(prev => ({
      ...prev,
      clientId: selectedClientId,
      clientPhone: selectedClient ? selectedClient.mobile_num : ''
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      documents: e.target.files
    }));
  };

  const officialId = localStorage.getItem("official_id");
  const official_name =  localStorage.getItem("official_name");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const formPayload = new FormData();

    // Adding necessary data to the FormData object
    formPayload.append('meeting_link', formData.meetLink);
    formPayload.append('official_id', officialId);
    formPayload.append('start_date', formData.startDate);
    formPayload.append('end_date', formData.endDate);
    formPayload.append('start_time', formData.startTime);
    formPayload.append('end_time', formData.endTime);
    formPayload.append('title', formData.eventTitle);
    formPayload.append('description', formData.eventDescription);
    formPayload.append('client_id', formData.clientId);

    // If files are uploaded, append them under 'upload_documents'
    if (formData.documents) {
      Array.from(formData.documents).forEach(file => {
        formPayload.append('upload_documents', file);
      });
    }

    try {
      const response = await fetch('https://admindashboard.clns.in/api/off_client/add_meeting/', {
        method: 'POST',
        body: formPayload,
      });

      const data = await response.json();

      if (response.ok) {
        console.log('Event successfully created:', data);
        alert("added successfully") // Redirect to the home page after a successful submission
      } else {
        console.error('Error:', data);
        // Handle error response
      }
    } catch (error) {
      console.error('Error while submitting form:', error);
      // Handle network error
    }
  };

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f9fafb', padding: '24px' }}>
      <div style={{ maxWidth: '800px', margin: '0 auto' }}>
        <button 
          onClick={() => navigate(-1)} 
          style={{ marginBottom: '24px', padding: '10px 20px', backgroundColor: 'transparent', border: '1px solid #007bff', color: '#007bff', cursor: 'pointer' }}
        >
          Back
        </button>

        <h1 style={{ fontSize: '24px', fontWeight: '500', marginBottom: '24px' }}>
          Add Event based on official availability
        </h1>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <input
            type="text"
            placeholder="Official Name / ID"
            name="officialNameId"
            disabled
            value={official_name}
            onChange={handleInputChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>Start Date</label>
              <input
                type="date"
                name="startDate"
                value={formData.startDate}
                onChange={handleInputChange}
                style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>Start Time</label>
              <input
                type="time"
                name="startTime"
                value={formData.startTime}
                onChange={handleInputChange}
                style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
              />
            </div>
          </div>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>End Date</label>
              <input
                type="date"
                name="endDate"
                value={formData.endDate}
                onChange={handleInputChange}
                style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
              />
            </div>
            <div>
              <label style={{ display: 'block', marginBottom: '8px' }}>End Time</label>
              <input
                type="time"
                name="endTime"
                value={formData.endTime}
                onChange={handleInputChange}
                style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
              />
            </div>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '8px' }}>Select Client</label>
            <select
              name="clientId"
              value={formData.clientId}
              onChange={handleClientSelect}
              style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc', width: '100%' }}
            >
              <option value="">-- Select a client --</option>
              {loading ? (
                <option disabled>Loading clients...</option>
              ) : (
                clients.map(client => (
                  <option key={client.id} value={client.id}>
                    {client.name} ({client.mobile_num})
                  </option>
                ))
              )}
            </select>
          </div>

          <div>
            <label style={{ display: 'block', marginBottom: '8px' }}>Client Phone</label>
            <input
              type="text"
              name="clientPhone"
              value={formData.clientPhone}
              readOnly
              style={{ 
                padding: '10px', 
                borderRadius: '4px', 
                border: '1px solid #ccc',
                backgroundColor: '#f0f0f0',
                width: '100%'
              }}
            />
          </div>

          <input
            type="text"
            placeholder="Event Title"
            name="eventTitle"
            value={formData.eventTitle}
            onChange={handleInputChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />

          <textarea
            placeholder="Event Description"
            name="eventDescription"
            value={formData.eventDescription}
            onChange={handleInputChange}
            rows={3}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />

          <input
            type="text"
            placeholder="Google Meet/Link"
            name="meetLink"
            value={formData.meetLink}
            onChange={handleInputChange}
            style={{ padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
          />

          <div>
            <p style={{ marginBottom: '8px' }}>Attach Documents</p>
            <label style={{ border: '1px solid #ccc', borderRadius: '4px', padding: '16px', display: 'block', cursor: 'pointer' }}>
              <input
                type="file"
                onChange={handleFileChange}
                multiple
                style={{ display: 'none' }}
              />
              <span style={{ color: '#007bff' }}>Upload Files</span>
              {formData.documents && (
                <span style={{ marginLeft: '10px', color: '#444' }}>
                  {Array.from(formData.documents).length} file(s) selected
                </span>
              )}
            </label>
          </div>

          <button 
            type="submit"
            style={{
              width: '100%',
              padding: '10px',
              backgroundColor: '#007bff',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            Save Event
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddEventForm;